// extracted by mini-css-extract-plugin
export default {"optionActive":"styles_optionActive__QSECw","optionLabel":"styles_optionLabel__z5yQe"};